import React from 'react'

import FieldAddress from "../address"
import HintPopover from "../../../../gd-ui/hint-popover/hint-popover"
import ErrorBoundary from "../../../../error-boundary"

type FieldFormulaViewProps = {
    className?  : string

    field       : FieldAddress
    model       : any

    options?    : any
    onClick?    : onClick
}

// const debug = "FieldAddress_ViewProperty"
const debug = false

export default function FieldAddress_ViewProperty(props: FieldFormulaViewProps) {
    const displayValue = props.field.getDisplayValue(props.field.getViewValue(props.model))

    debug && console.log(debug, 'render', props.field)

    return (
        <ErrorBoundary>
            <div className="ui5-property">
                <div className={Classes("ui5-ico-12 m-r-5", props.field.icon)}/>
                {displayValue}
                <HintPopover hint={props.field.label}/>
            </div>
        </ErrorBoundary>
    )
}
